import React, { useRef, useEffect } from "react";
import {
  Typography,
  Box,
  Container,
  Breadcrumbs,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  useMediaQuery,
} from "@mui/material";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { NavigateNext } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import PageHeaderWithBreadcrumbs from "../components/common/PageHeaderWithBreadcrumbs";
import PageTitle from "../components/common/PageTitle";
import {
  Assignment,
  Language,
  Security,
  CheckCircle,
  Schedule,
  AttachMoney,
} from "@mui/icons-material";

const VisaOptions = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const contentRef = useRef(null);
  const { i18n } = useTranslation();
  useEffect(() => {
    // if (contentRef.current) {
    //   const stickyHeader = document.querySelector("[data-sticky-header]");
    //   const headerHeight = stickyHeader ? stickyHeader.offsetHeight : 0;
    //   const elementTop = contentRef.current.offsetTop;
    //   const padding = 120;
    //   window.scrollTo({
    //     top: elementTop - headerHeight - padding,
    //     behavior: "smooth",
    //   });
    // }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const visaData = [
    {
      name: t("visaOptions.table.rows.eta.name"),
      type: t("visaOptions.table.rows.eta.type"),
      description: t("visaOptions.table.rows.eta.description"),
      learnMore: t("visaOptions.table.rows.eta.learnMore"),
      actions: [
        {
          variant: "secondary",
          text: t("visaOptions.table.rows.eta.checkEligibility"),
          action: () => window.location.href = process.env.REACT_APP_SITE+`EligibilityNational?lang=${i18n.language}`,
        },
        {
          variant: "primary",
          text: t("visaOptions.table.rows.eta.createApplication"),
          action: () => window.location.href = process.env.REACT_APP_SITE+`etail?lang=${i18n.language}`,
        },
      ],
    },
    {
      name: t("visaOptions.table.rows.student.name"),
      type: t("visaOptions.table.rows.student.type"),
      description: t("visaOptions.table.rows.student.description"),
      actions: [],
    },
    {
      name: t("visaOptions.table.rows.clergyman.name"),
      type: t("visaOptions.table.rows.clergyman.type"),
      description: t("visaOptions.table.rows.clergyman.description"),
      actions: [],
    },
    {
      name: t("visaOptions.table.rows.work.name"),
      type: t("visaOptions.table.rows.work.type"),
      description: t("visaOptions.table.rows.work.description"),
      actions: [],
    },
    {
      name: t("visaOptions.table.rows.expert.name"),
      type: t("visaOptions.table.rows.expert.type"),
      description: t("visaOptions.table.rows.expert.description"),
      actions: [],
    },
    {
      name: t("visaOptions.table.rows.tourist.name"),
      type: t("visaOptions.table.rows.tourist.type"),
      description: t("visaOptions.table.rows.tourist.description"),
      learnMore: t("visaOptions.table.rows.tourist.learnMore"),
      actions: [
        {
          variant: "primary",
          text: t("visaOptions.table.rows.eta.createApplication"),
          action: () => window.location.href = process.env.REACT_APP_SITE+`evisa?lang=${i18n.language}`,
        },
      ],
    },
    {
      name: t("visaOptions.table.rows.volunteer.name"),
      type: t("visaOptions.table.rows.volunteer.type"),
      description: t("visaOptions.table.rows.volunteer.description"),
      actions: [],
    },
  ];

  return (
    <>
      <PageTitle pageKey="visaOptions" titleKey="pageTitles.visaOptions" fallbackTitle={t("pageTitles.visaOptions")} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          background: "#E8EDF6",
          py: { xs: 2, md: 0 },
        }}
      >
        <PageHeaderWithBreadcrumbs
          breadcrumbs={[
            { text: t("visaOptions.breadcrumbs.home"), href: "/" },
            { text: t("visaOptions.breadcrumbs.visaOptions") },
          ]}
          title={t("visaOptions.header.title")}
          applyButtonText={false}
          sticky={false}
        />
        <Container maxWidth="lg">
          {/* Bloc principal */}
          <Box
            sx={{
              background: "#fff",
              borderRadius: 1,
              boxShadow: "0 2px 16px rgba(24,59,86,0.07)",
              px: { xs: 2, sm: 2, md: 6 },
              py: { xs: 2, sm: 3, md: 5 },
              mb: 5,
            }}
          >
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 700,
                color: "#183B56",
                mb: 2,
                width: { xs: "100%", md: "80%" },
                fontSize: { xs: "1.3rem", md: "1.5rem" },
              }}
            >
              {t("visaOptions.header.description")}
            </Typography>
            <Box sx={{ mb: 1 }}>
              <Typography
                component="h3"
                sx={{
                  color: "#FF6B35",
                  fontWeight: 700,
                  fontSize: { xs: "1.2rem", md: "1.5rem" },
                }}
              >
                {t("visaOptions.header.visitingIsrael")}
              </Typography>
              <Typography
                component="p"
                sx={{
                  color: "#183B56",
                  fontWeight: 400,
                  width: { xs: "100%", md: "80%" },
                  fontSize: { xs: "1rem", md: "1.1rem" },
                }}
              >
                {t("visaOptions.header.visitingIsraelRest")}
                <Link
                tabIndex={0}
                  onClick={() => window.location.href = process.env.REACT_APP_SITE+`EligibilityNational?lang=${i18n.language}`}
                  sx={{
                    color: "#0066CC",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontWeight: 500,
                  }}
                >
                  {t("visaOptions.header.checkEligibility")}
                </Link>{" "}
                {t("visaOptions.header.discoverOption")}
              </Typography>
            </Box>
            <Typography
              variant="body2"
              sx={{
                color: "#183B56",
                fontSize: { xs: "0.95rem", md: "1rem" },
                mb: 1,
              }}
            >
              {t("visaOptions.header.moreInfo")}{" "}
              <Link
                href="https://www.gov.il/en/departments/dynamiccollectors/israeli-consular-services?skip=0"
                target="_blank"
                sx={{
                  color: "#0066CC",
                  textDecoration: "underline",
                  fontWeight: 500,
                }}
                aria-label={t("common.externalGovLink")}
                
              >
                {t("visaOptions.header.embassyList")}
              </Link>
            </Typography>

            {/* Tableau accessible */}
            <TableContainer
              id="table"
              component={Paper}
              sx={{
                // boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: 1,
                overflow: "auto",
                mt: 3,
                maxWidth: "100%",
              }}
            >
              <Table
                sx={{ minWidth: 650 }}
                aria-label={t("visaOptions.table.ariaLabel")}
              >
                <TableHead>
                  <TableRow sx={{ backgroundColor: "#F3F6FA" }}>
                    <TableCell
                      sx={{
                        fontWeight: 700,
                        color: "#183B56",
                        fontSize: "1.1rem",
                        py: 2,
                        width: { xs: "20%", md: "20%" },
                      }}
                    >
                      {t("visaOptions.table.headers.visaName")}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 700,
                        color: "#183B56",
                        fontSize: "1.1rem",
                        py: 2,
                        width: { xs: "20%", md: "20%" },
                      }}
                    >
                      {t("visaOptions.table.headers.type")}
                    </TableCell>
                    <TableCell
                      sx={{
                        fontWeight: 700,
                        color: "#183B56",
                        fontSize: "1.1rem",
                        py: 2,
                        width: { xs: "60%", md: "60%" },
                      }}
                    >
                      {t("visaOptions.table.headers.moreInfo")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {visaData.map((visa, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        backgroundColor: index % 2 === 0 ? "#F3F6FA" : "#fff",
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        sx={{
                          fontWeight: 700,
                          color: "#183B56",
                          fontSize: "1rem",
                          py: 3,
                          verticalAlign: "top",
                        }}
                      >
                        {visa.name}
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: 700,
                          color: "#183B56",
                          fontSize: "1rem",
                          py: 3,
                          verticalAlign: "top",
                        }}
                      >
                        {visa.type}
                      </TableCell>
                      <TableCell sx={{ py: 3, verticalAlign: "top" }}>
                        <Typography
                          variant="body2"
                          sx={{
                            lineHeight: 1.6,
                            mb: 2,
                            color: "#183B56",
                          }}
                        >
                          {visa.description}{" "}
                         {visa.learnMore && <RouterLink
                            to="/learn-about"
                            style={{
                              textDecoration: "none",
                              color: "#0046E3",
                              // fontSize: "0.9rem",
                              // fontWeight: 300,
                              "&:hover": {
                                color: "#2e6cb4 !important",
                              },
                            }}
                            onMouseOver={(e) =>
                              (e.currentTarget.style.textDecoration = "underline")
                            }
                            onMouseOut={(e) =>
                              (e.currentTarget.style.textDecoration = "none")
                            }
                          >
                            {visa.learnMore}
                          </RouterLink>}
                        </Typography>
                        {visa.actions.length > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              mt: 1,
                            }}
                          >
                            {visa.actions.map((action, actionIndex) => (
                              <Button
                                key={actionIndex}
                                variant={action.variant}
                                size={isMobile ? "small" : "medium"}
                                onClick={action.action}
                                type="link"
                              >
                                {action.text}
                              </Button>
                            ))}
                          </Box>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default VisaOptions;
